/** Элемент страницы по id. Нет такого — ошибка разметки, и молчать о ней незачем. */
export function el<T extends HTMLElement = HTMLElement>(id: string): T {
  const found = document.getElementById(id);
  if (!found) throw new Error(`нет элемента #${id}`);
  return found as T;
}
